import type { RouteConfig } from "vue-router";

import OrganizationDashboardController from "@Resources/js/modules/teams/OrganizationDashboardController.vue";
import HlpLazyLoadView from "@Helpers/functions/lazyLoadView";
import isUserLoggedIn from "@Middleware/isUserLoggedIn";

import TeamSettings from "./TeamSettings";
import PurchaseRoutes from "@Modules/shoppingcart/routes/PurchaseRoutes";

const OrganizationVerifyController = () => import("@Modules/shoppingcart/Controllers/OrganizationVerifyController.vue");
const OrganizationOrderController = () => import("@Modules/shoppingcart/Controllers/OrganizationOrderController.vue");
const OrganizationOrdersController = () => import("@Modules/shoppingcart/Controllers/OrganizationOrdersController.vue");

export default function OrganizationRoutes(): RouteConfig {
    return {
        path: "/app/organizations",
        component: HlpLazyLoadView("organizations/Index"),
        children: [
            ...TeamSettings(),
            ...PurchaseRoutes(),
            { path: "/app/organizations", name: "org.onboarding", component: HlpLazyLoadView("organizations/Onboarding") },
            {path: ":org/dashboard", name: "org.dashboard", component: OrganizationDashboardController },
            /**
             * Temporary 307 redirection.
             * Only for MVP, dashboard for organization is not available
             * for any user for MVP.
             */
//            { path: ":org/dashboard", name: "org.dashboard", redirect: { name: "dashboard" } },
            { path: ":org/team/:team", name: "org.team", component: OrganizationDashboardController },
            { path: ":org/helpdesk", name: "org.helpdesk", component: HlpLazyLoadView("organizations/Helpdesk") },
            { path: ":org/audit", name: "org.audit", component: HlpLazyLoadView("organizations/Audit") },
            { path: ":org/shopping-cart/success", name: "org.shopping-cart.verify", component: OrganizationVerifyController },
            { path: ":org/settings/orders", name: "org.shopping-cart.orders", component: OrganizationOrdersController },
            { path: ":org/settings/order/:orderId", name: "org.shopping-cart.orders.order", component: OrganizationOrderController },
        ].map((r) => ({
            ...r,
            meta: { navbarEnabled: true, middleware: [isUserLoggedIn] },
        })),
    };
}
